var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.trainerId)?_c('v-card',{staticClass:"pa-2 ma-0",class:_vm.$vuetify.theme.dark ? 'transparent03--dark' : 'transparent03'},[_c('TrainerBlock',{key:"trainer",attrs:{"reverse":_vm.reverse,"trainer-id":_vm.trainerId,"obstacle-view":_vm.obstacleView}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }